Ext.define('SA.ChartLegendHeader', {
    alias: 'widget.chart-legend-header',
    extend: 'Ext.Component',

    cls: 'sa-chart-legend-header',

    setIsSummaryMode(isSummaryMode) {
        this.update(isSummaryMode ? 'Legend' : 'Edit Legend');
    }
});